/**
 * Neutral TravelBio-branded placeholder — rendered on override cards
 * when the override has ZERO photos.  Matches Stay22's image aspect
 * ratio so layout stays consistent.  Cardinal Rule: this is a
 * traveler surface, never used on Atlas.
 */
export default function OverridePlaceholderImage({ name = "TravelBio" }) {
  return (
    <div
      data-testid="override-placeholder-image"
      className="absolute inset-0 flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #0f1e33 0%, #16324f 55%, #1a3a5f 100%)",
      }}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(224,181,79,0.6) 0px, transparent 40%), radial-gradient(circle at 80% 80%, rgba(224,181,79,0.4) 0px, transparent 40%)",
        }}
      />
      <div className="relative z-10 px-4 text-center">
        <div className="text-tb-gold-bright/95 font-serif text-lg leading-tight drop-shadow-sm">
          {name}
        </div>
        <div className="mt-1 text-[10px] tracking-[0.35em] uppercase text-white/60 font-hand">
          TravelBio Selected
        </div>
      </div>
    </div>
  );
}
